<template>
  <div>
    <v-alert type="info"
             tile
             class="mb-4">
      <strong>PREVIEW: </strong>This is how the disclaimer will appear in the browser.
    </v-alert>
    <DisclaimerCard :disclaimer="disclaimer"
                    :mockup="true">
    </DisclaimerCard>
  </div>
</template>
<script>
import DisclaimerCard from "./DisclaimerCard.vue";

export default {
  components: {DisclaimerCard},
  props: {
    disclaimer: {
      type: Object,
      required: true,
    }
  }
}
</script>
